<template>
  <main class="main">
    <router-view :key="$route.fullPath"/>
  </main>
</template>

<script>

export default {
  name: 'InMain',
  props: ['currentMenu']
}
</script>

<style scoped>
main {
  width:calc(100% - 250px);
  margin-left: 250px;
  margin-bottom:15px;
  padding-top: 10px;
  box-sizing: border-box;
}
.menu-close + .main {margin-left: 0;width: 100%;}
@media (max-width: 1092px) {
  main {min-width: 1600px;padding-top: 50px;}
  main:has(.demo-overview), main:has(.menu-preview), main:has(.sample-detail) {min-width: 0;}
}
</style>
